import script from "./InquiryDetailResponsesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryDetailResponsesSection.vue?vue&type=script&setup=true&lang=ts"

import "./InquiryDetailResponsesSection.vue?vue&type=style&index=0&id=4150082c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4150082c"]])

export default __exports__